import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ApiService } from '../api.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'lib-dialog-overview-confirmation',
  templateUrl: './dialog-overview-confirmation.component.html',
  styleUrls: ['./dialog-overview-confirmation.component.scss']
})
export class DialogOverviewConfirmationComponent implements OnInit {
  confirmData: any;
  onlyDelete=false;
  profileModify=false;
  notDelProfile=false;
  consentConfirm=false;
  selectedPlan:any={};
  appDeSubscribe = false;
  showPlanFlag = false;
  facilityInfo:any={
    facilityName:''
  }
  hide = true;
  planData:any={}
  setChange:boolean=false;
  subscriptionPlan:Array<any>=[];
  wrongEmail:boolean=false;
  planInfo:any={};
  requestedPlan:any={};
  submitted:boolean=false;
  @ViewChild('passwordModel') passwordModel;
  @ViewChild('commentsModel') commentsModel;
  @ViewChild('emailModel') emailModel;
  email;
  comments:string="";
  userName:string='';
  selectedIndex:number=-1;
  selectedPlanName:String= "";
  emailVal;
  authPassword;
  planType = 'monthlyPlan';
  modifyData:any;
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<DialogOverviewConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.userName=JSON.parse(localStorage.getItem('userObject')).userId;
    if(this.confirmData.delUser == true){
      this.onlyDelete = true;
      this.notDelProfile = false;
      this.profileModify = false;
      this.appDeSubscribe = false;
      this.showPlanFlag = false;
      this.email = this.confirmData.delData.email;
    }
    if(this.confirmData.profileUpdate == true){
      this.profileModify = true;
      this.notDelProfile = false;
      this.appDeSubscribe = false;
      this.onlyDelete = false;
      this.showPlanFlag = false;
    } 
    if(this.confirmData.changePass == true){
      this.profileModify = false;
      this.appDeSubscribe = false;
      this.notDelProfile = true;
      this.onlyDelete = false;
      this.showPlanFlag = false;
    }
    if(this.confirmData.privacyConfirm == true){
      this.profileModify = false;
      this.notDelProfile = false;
      this.appDeSubscribe = false;
      this.onlyDelete = false;
      this.consentConfirm = true;
      this.showPlanFlag = false;
    }
    if(this.confirmData.unsubscribeAppData == true){
      this.profileModify = false;
      this.notDelProfile = false;
      this.onlyDelete = false;
      this.consentConfirm = false;
      this.appDeSubscribe = true;
      this.showPlanFlag = false;
    }
    if(this.confirmData.subscriptionPlanDetails == true){
      this.profileModify = false;
      this.notDelProfile = false;
      this.onlyDelete = false;
      this.consentConfirm = false;
      this.appDeSubscribe = false;
      this.showPlanFlag = true;
      this.planData = this.confirmData.planData;
      this.selectedIndex = this.planData.planInfo ? this.planData.planInfo.planId : -1;
      this.selectedPlanName = this.planData.planInfo ? this.planData.planInfo.planName : "";

      this.requestedPlan = this.planData.planInfo.requestedPlan;
      this.facilityInfo = this.confirmData.facilityData;
      if(this.planData.applicationSettings.length){
        let countryData = this.planData.applicationSettings.find(res => res.country == localStorage.getItem('countryVal'));
        this.subscriptionPlan = countryData.subscriptionPlans;
        this.planInfo = this.confirmData.planData.planInfo;
      }
    }
  }
  planChange(value){
    this.setChange  = true;
    this.selectedPlan = this.subscriptionPlan.find((res,index) => {
      // this.selectedIndex = index;
      return res.planId == value
    });
  }
  selectRequest(){
    if(Object.keys(this.selectedPlan).length)
    this.requestPlan(this.selectedPlan);
  }
  requestPlan(data){
    this.dialogRef.close({ event: 'planSent' });
  }
  onCloseDialog () : void  {
    this.submitted = false;
    this.dialogRef.close({ event: 'cancel' });
  }
  onAppUpdate() {
    this.submitted = true;
    if (this.commentsModel.invalid) {
      return false;
    }
    this.dialogRef.close({ event: 'appModify',notes:this.comments });
  }
  onClose(event) {
    event.preventDefault();
    this.dialogRef.close({ event: 'confirm' });
  }
  encryptUsingAES256(data:any) {
    let _key = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let encrypted = CryptoJS.AES.encrypt(
      data, _key, {
        keySize: 128 / 8,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }
  planTypeChange(event) {
  }
  onModify(){
    this.submitted = true;
    if (this.passwordModel.invalid) {
      return false;
    }
    const formDetails = {
      password:this.encryptUsingAES256(this.authPassword)
    }
    this.apiService.profileEditAuth(formDetails).subscribe({
      next: (data: any) => {
       console.log(data);
       this.dialogRef.close({ event: 'profileMoify' });
      },
      error: err => {
        this.dialogRef.close({ event: 'profileMoifyError' , message:err.error.message});
       },
      complete: () => { }
    })
  }
  onConfirmDelete() {
    this.submitted = true;
    if (this.emailModel.invalid) {
      return false;
    } 
    this.email = this.email.toLowerCase();
    this.emailVal = this.emailVal.toLowerCase();
    if(this.email == this.emailVal) {
      this.wrongEmail = false;
      this.dialogRef.close({ event: 'confirmDelete' });
    } else {
      this.wrongEmail = true;
      return false;
    }
  }
  onCloseDialogConsern(){
    this.submitted = false;
    this.dialogRef.close({ event: 'cancelConsern' });
  }
  onConsernUpdate(){
    const formData = {
      isConsentAgreed:false,
      userId:this.confirmData.userId
    }
    this.apiService.updateConsent(formData).subscribe({
      next: (data: any) => {
        if(data){
          this.dialogRef.close({ event: 'consentModify' });
        }
      },
      error: err => {
        //this.dialogRef.close({ event: 'profileMoifyError' , message:err.error.message});
       },
      complete: () => { }
    })
  }
}
